import i18n from "@/i18n";

var plugin = {};

/*中文转拼音功能*/
// import chineseToPinYin from "@/components/commonTool/chineseToPinYin/chineseToPinYin.js"

plugin.install = function (Vue,options) {

  Vue.directive("drag",function (el,bind,vnode,oldVnode) {

    var domObj = el;
    if(el.children.moveZone){
      domObj = el.children.moveZone;
    }
    domObj.style.cursor = "move";

    // 移动事件触发 元素 绑定 鼠标点击事件
    domObj.onmousedown=function(e){
      //获取当前 元素所处在的 left top 值
      let l=e.clientX-el.offsetLeft;
      let t=e.clientY-el.offsetTop;

      // 获取元素的 父级元素的 宽度  高度
      let parentWidth = el.parentNode.clientWidth;
      let parentHeight = el.parentNode.clientHeight;

      //如果元素 是 fixed 属性 那么 就是相当于 整个 页面为限制宽 高值
      if(el.style.position == "fixed"){
        if(window.innerWidth){
          parentWidth = window.innerWidth;
          parentHeight = window.innerHeight;
        }else if(document.body && document.body.clientWidth){
          parentWidth = window.body.clientWidth;
          parentHeight = window.body.clientHeight;
        }
      }

      //获取当前元素的 宽度 高度
      let selfWidth = el.clientWidth;
      let selfHeight = el.clientHeight;

      //鼠标按下事件触发时 帮点document的 移动事件
      document.onmousemove=function(e){
        //获取元素的left 值
        let leftV = e.clientX-l;
        if(leftV < 0){// 防止超出边界
          leftV = 0;
        }
        if(leftV > parentWidth - selfWidth){// 防止超出边界
          leftV = parentWidth - selfWidth;
        }
        el.style.left = leftV+'px';

        //获取元素的top 值
        let topV = e.clientY-t;
        if(topV < 0){// 防止超出边界
          topV = 0;
        }
        if(topV > parentHeight - selfHeight){// 防止超出边界
          topV = parentHeight - selfHeight;
        }
        el.style.top = topV+'px';

      };

      // document 帮点鼠标 松开事件，清楚上面绑定的事件
      document.onmouseup=function(){
        document.onmouseup = null;
        document.onmousemove = null;
      }

    }

  });

  Vue.directive('focusNextOnEnter', {
    bind: function(el, {value}, vnode) {

      var inputs = $(el).find("input,textarea,.selected-text");
      inputs.unbind("keydown").bind('keydown',function (e) {

        var k = e.keyCode;
        var a=inputs.index($(this));//jquery 获取数组元素的下标,两种方法

        if (k == 13) {
          if(a+1 < inputs.length){

            var dom = inputs[a+1];

            if($(dom).attr("class") == "selected-text"){
              inputs[a].blur();
              $(dom).trigger('click');
            }else{
              dom.focus();
              dom.select();
            }

          }
          return false;
        }

      })
    },
    componentUpdated:function(el, {value}, vnode) {

      var inputs = $(el).find("input,.selected-text");
      inputs.unbind("keydown").bind('keydown',function (e) {

        var k = e.keyCode;
        var a=inputs.index($(this));//jquery 获取数组元素的下标,两种方法

        // console.log(k)

        if (k == 13 || k == 39 ) {
          if(a+1 < inputs.length){

            var dom = inputs[a+1];

            if($(dom).attr("class") == "selected-text"){
              inputs[a].blur();
              $(dom).trigger('click');
            }else{
              dom.focus();
              dom.select();
            }

          }
          return false;
        }

      })
    }
  });

  Vue.mixin({
      methods:{
        /**方法功能：
        * 对表格排序功能进行封装
        * 参数:
        * tableData:当前数据
        * oldTableData:没有进行任何排序时的数据。
        * params:对象，sortFiled 排序列  sortList 排序方式
        * type:暂时未定义使用 预留
        * */
        tableSort:function(tableData,oldTableData,params,type){
          var sortFiled = params.sortFiled;
          var sortType = params.sortList[sortFiled];

          if(type == "date"){

          }else{
            if(sortType == "desc"){
              tableData.sort(function (a,b) {
                if(a[sortFiled].value < b[sortFiled].value){
                  return 1;
                }else if(a[sortFiled].value > b[sortFiled].value){
                  return -1;
                }
                return 0;
              })
            }else if(sortType == "asc"){
              tableData.sort(function (a,b) {
                if(a[sortFiled].value > b[sortFiled].value){
                  return 1;
                }else if(a[sortFiled].value < b[sortFiled].value){
                  return -1;
                }
                return 0;
              })
            }else{
              tableData = this.cloneData(oldTableData);
            }
          }
          return tableData;
        },
        /**
        * 方法功能：
        * 对表格的列进行左右移动
        * 参数：
        * type: changeStyle / moveRow 分别为 改变单元格样式  /  移动 row
        * data:table 组件返回的数据
        * tableData：tableData 的数据
        * columnsData：table 表头的数据
        * */
        moveTableRow:function (type,data,tableData,columnsData) {

          //改变单元格样式
          if(type == "changeStyle"){
            if(data.title == "title"){
              for(var i=0;i<columnsData.length;i++){
                if(columnsData[i].field == data.field){
                  columnsData[i].cellStyle = data.cellStyle;
                }
              }
            }else if(data.title == "content"){
              tableData[data.rowIndex][data.field].cellStyle = data.cellStyle;
            }

            return {
              tableData:tableData,
              columnsData:columnsData
            }

          }

          /*移动表头*/
          if(type == "moveRow"){

            var field = data.field;
            var direction = data.direction;

            for(var i=0;i<columnsData.length;i++){
              var tempData = columnsData[i];

              if(tempData.field == field){

                if(direction == "left"){
                  var columnsOne = columnsData[i];
                  if(i < columnsData.length - 1){
                    columnsData[i] = columnsData[i+1];
                    columnsData[i+1] = columnsOne;
                  }
                }else if(direction == "right"){
                  var columnsOne = columnsData[i];
                  if(i != 0){
                    columnsData[i] = columnsData[i-1];
                    columnsData[i-1] = columnsOne;
                  }
                }

                return {
                  tableData:tableData,
                  columnsData:columnsData
                };

                break;
              }
            }
          }
        },
        /**
        * 方法功能：
        * 时间戳 转 时间，或者 时间 转 时间戳
        * data: 时间 或 时间戳
        * dataFormat:你需要的 时间格式 默认为：yyyy-mm-dd hh:mm:ss
         * dateStartEnd:事件的 开始或者结束 有值或为true 就是开始，没有值或者false 就是 结束
        * */
        dateMagic:function (data,dataFormat,dateStartEnd) {
          /*如果 data 里面不包含 - / ： 其中任何一种 我们直接认为是 时间戳*/
          if(
            !isNaN(data)||(
            data.indexOf("-") == -1 &&
            data.indexOf("/") == -1 &&
            data.indexOf(":") == -1
            )
          ){
            if(!isNaN(data))
              data = parseInt(data);
            var date = new Date(data*1000);

            var year = date.getFullYear();
            var month = date.getMonth();
            var day = date.getDate();
            var hour = date.getHours();
            var minutes = date.getMinutes();
            var second = date.getSeconds();

            /**
            * 处理不同时期格式返回
            * 默认为 yyyy-mm-dd
            * */
            if(dataFormat == "yyyy-mm-dd"){
              return year+"-"+this.addZero(month+1)+"-"+this.addZero(day);
            }else if(dataFormat == "yyyy/mm/dd"){
              return year+"/"+this.addZero(month+1)+"/"+this.addZero(day);
            }else if(dataFormat == "yyyy/mm/dd hh:mm"){
              return year+"/"+this.addZero(month+1)+"/"+this.addZero(day)+" "+this.addZero(hour)+":"+this.addZero(minutes);
            }else if(dataFormat == "yyyy-mm-dd hh:mm"){
              return year+"-"+this.addZero(month+1)+"-"+this.addZero(day)+" "+this.addZero(hour)+":"+this.addZero(minutes);
            }else if(dataFormat == "yyyy-mm-dd hh:mm:ss"){
              return year+"-"+this.addZero(month+1)+"-"+this.addZero(day)+" "+this.addZero(hour)+":"+this.addZero(minutes)+":"+this.addZero(second);
            }else if(dataFormat == "yyyy/mm/dd hh:mm:ss"){
              return year+"/"+this.addZero(month+1)+"/"+this.addZero(day)+" "+this.addZero(hour)+":"+this.addZero(minutes)+":"+this.addZero(second);
            }else{
              return year+"-"+this.addZero(month+1)+"-"+this.addZero(day);
            }
          }else{
            if(data.indexOf("/") != -1){
              data.replace("/","-");
            }
            var date = null;
            if(data.indexOf(":") != -1){
              date = new Date(data);
            }else{
              if(dateStartEnd){
                date = new Date(data+" 23:59:59");
              }else{
                date = new Date(data+" 00:00:00");
              }
            }
            return date.getTime()/1000;//获取时间戳 并返回
          }
        },
        /**方法功能：
        * 给数据进行添 0 操作
        * 参数：
        * number：需要添加的数
        * type:保留
        * */
        addZero:function (number,type) {
          if(parseInt(number) < 10){
            return "0"+number;
          }else{
            return number;
          }
        },
        /**方法功能：
        * 深复制方法，支持字符 复制，引用中的 数据  对象 复制
        * 参数：
        * obj：需要拷贝的数据
        * */
        cloneData:function (obj) {
          var buf;
          if(obj instanceof Array){
            buf = [];
            var i = obj.length;
            while(i--){
              buf[i] = this.cloneData(obj[i]);
            }
            return buf;
          }else if(obj instanceof Object){
            buf = {};
            for(var k in obj){
              buf[k] = this.cloneData(obj[k]);
            }
            return buf;
          }else{
            return obj;
          }
        },
        /**处理 style 数据
        * 字符串样式修改为 样式对象 {fontSize:'16px'}
        * */
        styleDeal:function (inputStyle) {
          let outputStyle = {};
          if (inputStyle && inputStyle !== "") {
            let styleArr = [];
            if (inputStyle.indexOf(";") !== -1) {
              styleArr = inputStyle.split(";");
            } else {
              styleArr = [inputStyle];
            }
            styleArr.map(function(item) {
              // 解决类似background-image:url('https://xxxx.png');按照:切割的问题,导致url中:被切割的问题
              let isContainTwoColon = false; // 该boolean值是为了解决如果url本身就是被编码，后续恢复://导致的url格式混乱的问题
              if (item.indexOf('://') !== -1) {
                isContainTwoColon = true;
                item = item.replace('://', '%3a%2f%2f');
              }
              let itemArr = item.split(":");
              if (itemArr.length === 2) {
                itemArr[0] = itemArr[0].replace(/(^\s*|\s*$)/g, "")
                  .replace(/-(\w)/g,function(){
                    let args = arguments;
                    return args[1].toUpperCase();
                  });
                // 先恢复属性url中的://
                if (isContainTwoColon === true) {
                  itemArr[1] = itemArr[1].replace('%3a%2f%2f', '://');
                }
                itemArr[1] = itemArr[1].replace(/(^\s*|\s*$)/g, "");
                outputStyle[itemArr[0]] = itemArr[1];
              }
            });
          }
          return outputStyle;
        },
        /**方法功能：
        * 获取一个随机字符串
        * 参数：
        * number：返回字符串长度
        * */
        getRandomString(number) {
          var string = "qwertyuiopasdfghjklzxcvbnm123456789QWERTYUIOPLKJHGFDSAZXCVBNM";
          var tempString = "";
          for(var i=0;i<number;i++){
            var randomNum = parseInt(Math.random() * string.length);
            tempString += string[randomNum];
          }
          var date = new Date().getTime();
          return "random"+tempString+date;
        },
        /**方法功能：
        * 获取 或者 存储 参数数据
        * 参数：key 用于存储对象 或读取对象 的key 必需
        *      value 选传  有这个值为 存储数据 没有这个值为读取数据
        *      callBack 如果获取数据需要一个回调，用来将获取到的数据回传
        *       */
        customKeyValue:function (key,value,callBack,userStatus) {

          let userInfo = sessionStorage.getItem("userInfo");
          userInfo = JSON.parse(userInfo);

          if(!userStatus){
            key = key+"_"+userInfo.UserID;
          }

          if(value !== "" && value !== null){
            this.axios({
              method:"post",
              url:"/apc/other/config/save",
              params:{
                key:key
              },
              data:value,
              forbiddenLoad:true
            }).then(function (res) {
              if(callBack){
                callBack(res);
              }
            });
          }else{

            this.axios({
              method:"get",
              url:"/apc/other/config/read",
              params:{
                key:key
              },
              forbiddenPretreat:true,
              forbiddenLoad:true
            }).then(function (res) {
              if(callBack){
                callBack(res);
              }
            });
          }
        },

        /**
         * 批量 参数 获取或修改
         *   参数：key 用于存储对象 或读取对象 的key 必需
         *   value 选传  有这个值为 存储数据 没有这个值为读取数据
         *   callBack 如果获取数据需要一个回调，用来将获取到的数据回传
         * */
        batchKeyValue:function (keyArray,valueArray,callBack,userStatus) {
          let userInfo = sessionStorage.getItem("userInfo");
          userInfo = JSON.parse(userInfo);

          if(!userStatus){
            for(var i=0;i<keyArray.length;i++){
              keyArray[i] = keyArray[i]+"_"+userInfo.UserID;
            }
          }

          if(valueArray !== "" && valueArray !== null){

            let tempData = [];
            for(var i=0;i<keyArray.length;i++){

              let obj = {};
              obj.SubName = keyArray[i];
              obj.SubValue = valueArray[i];

              tempData.push(obj);
            }

            this.axios({
              method:"post",
              url:"/apc/other/config/batchsave",
              data:tempData,
              forbiddenLoad:true
            }).then(function (res) {
              if(callBack){
                callBack(res);
              }
            });
          }else{

            this.axios({
              method:"POST",
              url:"/apc/other/config/batchread",
              data:keyArray,
              forbiddenPretreat:true,
              forbiddenLoad:true
            }).then(function (res) {
              if(callBack){
                callBack(res);
              }
            });
          }
        },
        // /**
        // * 方法功能：
        // *   将字符串里面的所有中文转为 拼音
        // * 参数：
        // * value：需要转为的文字
        // * 返回值为：
        // * 例如 ‘今天好开心 a’
        // * Object {
        //   * pinyinLower: "jin tian hao kai xin a",
        //   * pinyinUpper: "JIN TIAN HAO KAI XIN a",
        //   * pinyinFirstLower: "jthkxa",
        //   * pinYinFirstUpper: "JTHKXa"
        //  * }
        // * */
        // chineseToPinYin:function (value) {
        //   return chineseToPinYin(value);
        // },

        createWebSocket:function (host,callBack) {
          var self = this;

          var loginInfo = JSON.parse(sessionStorage.getItem("loginInfo"));
          if(!loginInfo){//判断是否有 loginInfo
            return false;
          }

          var wsUrl = "ws://114.215.123.51:8010/"+host+"?esn="+encodeURIComponent(loginInfo.ESN)+"&token="+encodeURIComponent(loginInfo.JWTModelToken);

          // var wsUrl = "wss://api.graspishop.com:50010"+host+"?esn="+encodeURIComponent(loginInfo.ESN)+"&token="+encodeURIComponent(loginInfo.JWTModelToken);

          var socketObj = new WebSocket(wsUrl);

          var timer = null;

          socketObj.onopen = function () {
            console.log(i18n.t('plugin.socketOpen'));

            //连接成功， 重连计数 归零
            self.$store.commit('changeReconnectTimes',0);

            self.$store.commit('changeSocketStatus',true);

            if(callBack){
              callBack();
            }

            //心跳数据
            var data = JSON.stringify({Action:1,Parmas:{}});
            socketObj.send(data);
            //开启15秒一次的心跳
            timer = setInterval(function () {
              socketObj.send(data);
            },15000);

          };

          socketObj.onclose = function () {
            //关闭心跳
            clearInterval(timer);
            self.$store.commit('changeSocketStatus',false);
            console.log(i18n.t('plugin.socketClose'));

            //出错了，15秒后进行重连操作
            setTimeout(function () {
              self.reconnectSocket();
            },15000);

          };

          socketObj.onmessage = function (msg) {
            var msgData = JSON.parse(msg.data);
            // console.log(JSON.stringify(msgData));
            if(msgData.RetCode == 0){
              //代表返回的 是token 保存token
              if(msgData.ResultType == 1){
                console.log(i18n.t('plugin.tokenSuccess'));
                loginInfo.JWTModelToken = msgData.RetObject;
                sessionStorage.setItem("loginInfo",JSON.stringify(loginInfo));
              }
            }
          };

          socketObj.onerror = function (err) {
            //关闭心跳
            clearInterval(timer);
            self.$store.commit('changeSocketStatus',false);
            console.log("socket error");

            //出错了，15秒后进行重连操作
            setTimeout(function () {
              self.reconnectSocket();
            },15000);
          };

        },

        //进行重连操作
        reconnectSocket:function(){
          //读取重连次数
          var connectTimes = this.$store.state.socketData.reconnectTimes;
          //只进行5次重连
          if(connectTimes < 5){
            this.$store.commit('changeReconnectTimes');
            this.createWebSocket(this.$store.state.socketData.socketUrl);
          }else{
            this.$store.commit('changeReconnectTimes',0);
            this.$router.push({
              name:"panLogin"
            });
          }
        },
        /**
         *方法功能
         * 根据type类型返回对应的日期
         * 参数：
         * type 日期类型[1="今天"，2="昨天",3="本周",4="本月", 5="近3天", 6="近30天", 7="本季", 8="本年"]
         * fSuffix 开始日期后缀[0="没有后缀",1="00:00:00",2="23:59:59"]
         * eSuffix 结束日期后缀[0="没有后缀",1="00:00:00",2="23:59:59"]
         */
        getDate:function (type,fSuffix,eSuffix) {
          var date=new Date();
          var fs="",es="";
          switch (fSuffix) {
            case 1:
              fs=" 00:00:00";
              break;
            case 2:
              fs=" 23:59:59";
              break;
          }
          switch (eSuffix) {
            case 1:
              es=" 00:00:00";
              break;
            case 2:
              es=" 23:59:59";
              break;
          }
          switch (parseInt(type,10)) {
            case 1:
              return {
                "startTime":date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate()+fs,
                "endTime":date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate()+es
              };
            case 2:
              date.setDate(date.getDate()-1)
              return {
                "startTime":date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate()+fs,
                "endTime":date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate()+es
              };
            case 3:
              date.setDate(date.getDate()-date.getDay()+1)
              var retDate={"startTime":date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate()+fs};
              date.setDate(date.getDate()+6)
              retDate["endTime"]=date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate()+es;
              return retDate;
            case 4:
              date.setDate(1)
              var retDate={"startTime":date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate()+fs};
              date.setMonth(date.getMonth()+1);
              date.setDate(date.getDate()-1);
              retDate["endTime"]=date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate()+es;
              return retDate;
            case 5:
              var retDate={"endTime":date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate()+es}
              date.setDate(date.getDate() - 2)
              retDate["startTime"]=date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate()+fs;
              return retDate;
            case 6:
              var retDate={"endTime":date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate()+es}
              date.setDate(date.getDate() - 29)
              retDate["startTime"]=date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate()+fs;
              return retDate;
            case 7:
              var quarter = Math.ceil((date.getMonth() + 1)/3)
              var list = {
                1: ['1-1', '3-31'],
                2: ['4-1', '6-30'],
                3: ['7-1', '9-30'],
                4: ['10-1', '12-31']
              }
              return {
                "startTime":date.getFullYear()+"-"+list[quarter][0]+fs,
                "endTime":date.getFullYear()+"-"+list[quarter][1]+es
              };
            case 8:
              return {
                "startTime":date.getFullYear()+"-1-1"+fs,
                "endTime":date.getFullYear()+"-12-31"+es
              };
          }
        },
        /**
         * 该方法实现了文件下载的功能，并且制定文件的fileName
         * @param  {String} uri 目标文件地址
         * @param  {String} filename 想要保存的文件名称
         * 使用方法如：downLoadFile('https://github.com/vuejs/vue-router', 'vue-router.html');
         * 兼容IE10以上
         * 缺点：
         *    1、非同源会有跨域问题，需要服务端同学配合解决
         *    2、会预先加载（下载）文件，如果文件比较大，等待时间会比较长（暂时没有其他解决方案），建议点击之后新增一个loading效果
         */
        downloadFile(uri, filename) {
          /**
           * 获取 blob
           * @param  {String} url 目标文件地址
           * @return {Promise}
           */
          let getBlobValue = function(url) {
            return new Promise(resolve => {
              const xhr = new XMLHttpRequest();

              xhr.open("GET", url, true);
              xhr.responseType = "blob";
              xhr.onload = () => {
                if (xhr.status === 200) {
                  resolve(xhr.response);
                }
              };

              xhr.send();
            });
          }
          /**
           * 保存
           * @param  {Blob} blob
           * @param  {String} filename 想要保存的文件名称
           */
          let saveFile = function(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, filename);
            } else {
              const link = document.createElement("a");
              const body = document.querySelector("body");

              link.href = window.URL.createObjectURL(blob);
              link.download = filename;

              // fix Firefox
              link.style.display = "none";
              body.appendChild(link);

              link.click();
              body.removeChild(link);

              window.URL.revokeObjectURL(link.href);
            }
          }

          if (!(uri && uri !== "")) {
            console.log(i18n.t('plugin.fileUrlInvalid'));
            return false;
          }
          try {
            let isFileSaverSupported = !!new Blob();
            if (isFileSaverSupported) {
              getBlobValue(uri).then(blob => {
                saveFile(blob, filename);
              });
            } else {
              alert(i18n.t('plugin.chromeRequired'));
            }
          } catch (e) {
            alert(i18n.t('plugin.chromeRequired'));
          }
        },
        /*
        * 在data里面找到你要的数据
        * data：查找的数据源
        * key：在那个关键字里面找
        * equalValue：查找的等于值
        * */
        getWantData:function (data,key,equalValue) {
          let tempArray = [];
          for(var i=0;i<data.length;i++){
            if(data[i][key] == equalValue){
              tempArray.push(data[i]);
            }
          }
          return tempArray;
        },
        /**
         * 打印数据
         * */
        p:function (obj) {
          console.log(JSON.stringify(obj))
        },

        /**
         * 检测浏览器是不是ie 浏览器
         * */
        IEVersion:function() {
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
            var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
            var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
            if(isIE) {
              var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
              reIE.test(userAgent);
              var fIEVersion = parseFloat(RegExp["$1"]);
              if(fIEVersion == 7) {
                return 7;
              } else if(fIEVersion == 8) {
                return 8;
              } else if(fIEVersion == 9) {
                return 9;
              } else if(fIEVersion == 10) {
                return 10;
              } else {
                return 6;//IE版本<=7
              }
            } else if(isEdge) {
              return 'edge';//edge
            } else if(isIE11) {
              return 11; //IE11
            }else{
              return -1;//不是ie浏览器
            }
        },
        //获取浏览器信息
        checkUserInfo:function (userAgent) {
            var u = userAgent || navigator.userAgent;
            var self = this;
            var match = {
              //内核
              'Trident': u.indexOf('Trident') > 0 || u.indexOf('NET CLR') > 0,
              'Presto': u.indexOf('Presto') > 0,
              'WebKit': u.indexOf('AppleWebKit') > 0,
              'Gecko': u.indexOf('Gecko/') > 0,
              //浏览器
              'Safari': u.indexOf('Safari') > 0,
              'Chrome': u.indexOf('Chrome') > 0 || u.indexOf('CriOS') > 0,
              'IE': u.indexOf('MSIE') > 0 || u.indexOf('Trident') > 0,
              'Edge': u.indexOf('Edge') > 0,
              'Firefox': u.indexOf('Firefox') > 0,
              'Opera': u.indexOf('Opera') > 0 || u.indexOf('OPR') > 0,
              'Vivaldi': u.indexOf('Vivaldi') > 0,
              'UC': u.indexOf('UC') > 0 || u.indexOf(' UBrowser') > 0,
              'QQBrowser': u.indexOf('QQBrowser') > 0,
              'QQ': u.indexOf('QQ/') > 0,
              'Baidu': u.indexOf('Baidu') > 0 || u.indexOf('BIDUBrowser') > 0,
              'Maxthon': u.indexOf('Maxthon') > 0,
              'LBBROWSER': u.indexOf('LBBROWSER') > 0,
              '2345Explorer': u.indexOf('2345Explorer') > 0,
              'Sogou': u.indexOf('MetaSr') > 0 || u.indexOf('Sogou') > 0,
              'Wechat': u.indexOf('MicroMessenger') > 0,
              'Taobao': u.indexOf('AliApp(TB') > 0,
              'Alipay': u.indexOf('AliApp(AP') > 0,
              'Weibo': u.indexOf('Weibo') > 0,
              'Suning': u.indexOf('SNEBUY-APP') > 0,
              'iQiYi': u.indexOf('IqiyiApp') > 0,
              //操作系统平台
              'Windows': u.indexOf('Windows') > 0,
              'Linux': u.indexOf('Linux') > 0,
              'Mac': u.indexOf('Macintosh') > 0,
              'Android': u.indexOf('Android') > 0 || u.indexOf('Adr') > 0,
              'WP': u.indexOf('IEMobile') > 0,
              'BlackBerry': u.indexOf('BlackBerry') > 0 || u.indexOf('RIM') > 0 || u.indexOf('BB') > 0,
              'MeeGo': u.indexOf('MeeGo') > 0,
              'Symbian': u.indexOf('Symbian') > 0,
              'iOS': u.indexOf('like Mac OS X') > 0,
              //移动设备
              'Mobile': u.indexOf('Mobi') > 0 || u.indexOf('iPh') > 0 || u.indexOf('480') > 0,
              'Tablet': u.indexOf('Tablet') > 0 || u.indexOf('iPad') > 0 || u.indexOf('Nexus 7') > 0
            };
            if (match.Mobile) {
              match.Mobile = !(u.indexOf('iPad') > 0);
            }
            //基本信息
            var hash = {
              engine: ['WebKit', 'Trident', 'Gecko', 'Presto'],
              browser: ['Safari', 'Chrome', 'IE', 'Edge', 'Firefox', 'Opera', 'Vivaldi', 'UC', 'QQBrowser', 'QQ', 'Baidu', 'Maxthon', 'Sogou', 'LBBROWSER', '2345Explorer', 'Wechat', 'Taobao', 'Alipay', 'Weibo', 'Suning', 'iQiYi'],
              os: ['Windows', 'Linux', 'Mac', 'Android', 'iOS', 'WP', 'BlackBerry', 'MeeGo', 'Symbian'],
              device: ['Mobile', 'Tablet']
            };
            self.device = 'PC';
            self.language = (function () {
              var g = (navigator.browserLanguage || navigator.language);
              var arr = g.split('-');
              if (arr[1]) {
                arr[1] = arr[1].toUpperCase();
              }
              return arr.join('-');
            })();
            for (var s in hash) {
              for (var i = 0; i < hash[s].length; i++) {
                var value = hash[s][i];
                if (match[value]) {
                  self[s] = value;
                }
              }
            }
            //系统版本信息
            var osVersion = {
              'Windows': function () {
                var v = u.replace(/^.*Windows NT ([\d.]+);.*$/, '$1');
                var hash = {
                  '6.4': '10',
                  '6.3': '8.1',
                  '6.2': '8',
                  '6.1': '7',
                  '6.0': 'Vista',
                  '5.2': 'XP',
                  '5.1': 'XP',
                  '5.0': '2000'
                };
                return hash[v] || v;
              },
              'Android': function () {
                return u.replace(/^.*Android ([\d.]+);.*$/, '$1');
              },
              'iOS': function () {
                return u.replace(/^.*OS ([\d_]+) like.*$/, '$1').replace(/_/g, '.');
              },
              'Mac': function () {
                return u.replace(/^.*Mac OS X ([\d_]+).*$/, '$1').replace(/_/g, '.');
              }
            }
            self.osVersion = '';
            if (osVersion[self.os]) {
              self.osVersion = osVersion[self.os]();
            }
            //浏览器版本信息
            var version = {
              'Chrome': function () {
                return u.replace(/^.*Chrome\/([\d.]+).*$/, '$1');
              },
              'IE': function () {
                var v = u.replace(/^.*MSIE ([\d.]+).*$/, '$1');
                if (v == u) {
                  v = u.replace(/^.*rv:([\d.]+).*$/, '$1');
                }
                return v != u ? v : '';
              },
              'Edge': function () {
                return u.replace(/^.*Edge\/([\d.]+).*$/, '$1');
              },
              'Firefox': function () {
                return u.replace(/^.*Firefox\/([\d.]+).*$/, '$1');
              },
              'Safari': function () {
                return u.replace(/^.*Version\/([\d.]+).*$/, '$1');
              },
              'Opera': function () {
                return u.replace(/^.*Opera\/([\d.]+).*$/, '$1');
              },
              'Vivaldi': function () {
                return u.replace(/^.*Vivaldi\/([\d.]+).*$/, '$1');
              },
              'Maxthon': function () {
                return u.replace(/^.*Maxthon\/([\d.]+).*$/, '$1');
              },
              'QQBrowser': function () {
                return u.replace(/^.*QQBrowser\/([\d.]+).*$/, '$1');
              },
              'QQ': function () {
                return u.replace(/^.*QQ\/([\d.]+).*$/, '$1');
              },
              'Baidu': function () {
                return u.replace(/^.*BIDUBrowser[\s\/]([\d.]+).*$/, '$1');
              },
              'UC': function () {
                return u.replace(/^.*UC?Browser\/([\d.]+).*$/, '$1');
              },
              '2345Explorer': function () {
                return u.replace(/^.*2345Explorer\/([\d.]+).*$/, '$1');
              },
              'Wechat': function () {
                return u.replace(/^.*MicroMessenger\/([\d.]+).*$/, '$1');
              },
              'Taobao': function () {
                return u.replace(/^.*AliApp\(TB\/([\d.]+).*$/, '$1');
              },
              'Alipay': function () {
                return u.replace(/^.*AliApp\(AP\/([\d.]+).*$/, '$1');
              },
              'Weibo': function () {
                return u.replace(/^.*weibo__([\d.]+).*$/, '$1');
              },
              'Suning': function () {
                return u.replace(/^.*SNEBUY-APP([\d.]+).*$/, '$1');
              },
              'iQiYi': function () {
                return u.replace(/^.*IqiyiVersion\/([\d.]+).*$/, '$1');
              }
            };
            self.version = '';
            if (version[self.browser]) {
              self.version = version[self.browser]();
            }
        },
        /**
         * 四舍五入 保留小数的位数
         * 根据vuex 里面的 小数点位数
         * */
        roundNumber:function (number) {
          if(typeof(number)!="number") number=parseFloat(number);
          if(isNaN(number)) return 0;

          return parseFloat(number.toFixed(this.$store.state.baseData.Decimal));
        },
        /**
         * 数量
         * 四舍五入 保留小数的位数
         * 根据vuex 里面的 小数点位数
         * */
        roundQty:function (number,decimal) {

          if(!decimal) decimal=this.$store.state.baseData.QtyDecimal;

          if(typeof(number)!="number") number=parseFloat(number);
          if(isNaN(number)) return 0;

          return parseFloat((Math.round(number*Math.pow(10,decimal))/Math.pow(10,decimal)).toFixed(decimal));
        },
        /**
         * 价格
         * 四舍五入 保留小数的位数
         * 根据vuex 里面的 小数点位数
         * */
        roundPrice:function (number,decimal) {
          if(!decimal) decimal=this.$store.state.baseData.PriceDecimal;

          if(typeof(number)!="number") number=parseFloat(number);
          if(isNaN(number)) return 0;

          return parseFloat((Math.round(number*Math.pow(10,decimal))/Math.pow(10,decimal)).toFixed(decimal));

        },
        /**
         * 金额
         * 四舍五入 保留小数的位数
         * 根据vuex 里面的 小数点位数
         * */
        roundTotal:function (number,decimal) {
          if(!decimal) decimal=this.$store.state.baseData.TotalDecimal;

          if(typeof(number)!="number") number=parseFloat(number);
          if(isNaN(number)) return 0;

          return parseFloat((Math.round(number*Math.pow(10,decimal))/Math.pow(10,decimal)).toFixed(decimal));
        },
        /**
         * 折扣
         * 四舍五入 保留小数的位数
         * 根据vuex 里面的 小数点位数
         * */
        roundDis:function (number,decimal) {
          if(!decimal) decimal=this.$store.state.baseData.DisDecimal;

          if(typeof(number)!="number") number=parseFloat(number);
          if(isNaN(number)) return 0;

          return parseFloat((Math.round(number*Math.pow(10,decimal))/Math.pow(10,decimal)).toFixed(decimal));
        },
        goToLogin:function () {
          this.$router.push({
            name:"panLogin"
          });
        }
      },
  });

};

export default plugin;



// WEBPACK FOOTER //
// ./src/extra/plugin.js